export enum Theme {
    DARK_MODE='dark',
    DEFAULT='default'
}